// Exact category ordering from the legacy luxsova.com home page.
// Stored as slug arrays so we can look up the full category object
// (with image, count) from the /api/categories response.

export const WOMEN_SLUGS = [
  "a-handbags",
  "duffle-bag",
  "jewellery",
  "h-perfumes",
  "scarves",
  "women-sunglasses",
  "trolly-bags",
  "women-belts",
  "women-jackets",
  "women-pants",
  "women-denims",
  "women-skirts",
  "women-hats",
  "women-footwear",
  "women-loafers",
  "c-women-sneakers",
  "d-women-watches",
  "women-dresses",
  "women-tops-2",
  "women-loungewear",
  "women-shirts",
  "women-t-shirts",
  "women-intimates",
];

export const MEN_SLUGS = [
  "mens-formal-shoes",
  "mens-side-bags",
  "trousers",
  "mens-vacation-wear",
  "j-backpacks",
  "i-caps",
  "e-denims",
  "duffle-bag",
  "mens-loungewear",
  "jackets",
  "mens-belt",
  "a-mens-sneakers",
  "mens-tracksuits",
  "g-mens-watches",
  "h-perfumes",
  "mens-tops",
  "scarves",
  "b-shirts",
  "football-shirts",
  "d-slides",
  "sunglasses",
  "trolly-bags",
  "underwears",
  "mens-wallets",
];

/** Return category objects for the given slug allow-list.
 *  - Categories with a stored `order` (set via admin drag-and-drop) sort first,
 *    in ascending order.
 *  - Categories without an `order` fall back to the position in `slugs`.
 *  - Missing slugs are dropped silently. */
export function pickCategories(allCategories, slugs) {
  const map = new Map((allCategories || []).map((c) => [c.slug, c]));
  // Defense-in-depth: dedupe input slugs so accidental doubles in the
  // curated arrays never render the same tile twice on the home page.
  const seen = new Set();
  const deduped = slugs.filter((s) => {
    if (seen.has(s)) return false;
    seen.add(s);
    return true;
  });
  const items = deduped
    .map((s, i) => {
      const c = map.get(s);
      return c ? { ...c, __fallback_pos: i } : null;
    })
    .filter(Boolean);
  return items.sort((a, b) => {
    const ao = a.order;
    const bo = b.order;
    const aHas = typeof ao === "number";
    const bHas = typeof bo === "number";
    if (aHas && bHas) return ao - bo;
    if (aHas) return -1; // ordered ones come first
    if (bHas) return 1;
    return a.__fallback_pos - b.__fallback_pos;
  });
}
